/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Notetaker_Issue_Waiting_For_Permission_TitleInputs */



/**
* | output |
* | --- |
* | "Wundo is waiting for permission to record" |
*
* @param {Meeting_Notetaker_Issue_Waiting_For_Permission_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_notetaker_issue_waiting_for_permission_title = /** @type {((inputs?: Meeting_Notetaker_Issue_Waiting_For_Permission_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Notetaker_Issue_Waiting_For_Permission_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo wacht op toestemming om op te nemen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo attend l'autorisation d'enregistrer")
	return /** @type {LocalizedString} */ ("Wundo is waiting for permission to record")
});